import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';
const LedgerIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M8.25 0C8.45711 0 8.625 0.167893 8.625 0.375V0.75H10.5C10.7071 0.75 10.875 0.917894 10.875 1.125V9.375C10.875 9.58211 10.7071 9.75 10.5 9.75H10.125V11.25H10.5C10.7071 11.25 10.875 11.4179 10.875 11.625C10.875 11.8321 10.7071 12 10.5 12H2.625C1.80514 12 1.125 11.3199 1.125 10.5V2.625C1.125 1.58947 1.96447 0.75 3 0.75H4.875V0.375C4.875 0.167893 5.04289 0 5.25 0H8.25ZM5.625 4.71973L6.48486 3.85986L6.54346 3.81152C6.68902 3.7154 6.88699 3.73172 7.01514 3.85986L7.875 4.71973V0.75H5.625V4.71973ZM1.875 10.5C1.875 10.9056 2.21936 11.25 2.625 11.25H9.375V9.75H2.625C2.21936 9.75 1.875 10.0944 1.875 10.5ZM1.875 9.20654C2.09665 9.07632 2.35274 9 2.625 9H10.125V1.5H8.625V5.625C8.625 5.77666 8.53365 5.91338 8.39355 5.97144C8.25343 6.02948 8.09211 5.99739 7.98486 5.89014L6.75 4.65527L5.51514 5.89014C5.40789 5.99739 5.24657 6.02948 5.10645 5.97144C4.96634 5.91338 4.875 5.77666 4.875 5.625V1.5H3C2.37868 1.5 1.875 2.00368 1.875 2.625V9.20654Z" className="fill-current" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Svg width={12} height={12} {...props}>{t0}</Svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default LedgerIcon;